import { gql } from '@apollo/client';

const CREATE_JOIN_MUTATION = gql`
mutation CreateContact($contact: PartnerContactInput!) {
    createContact(contact: $contact) {
        type,
        lpsContact {
            joinId,
            propertyId,
            userId
        },
        rejectedReason
    }
}`;

const FETCH_SUBMARKET_ID = gql`
query FetchSubmarketId($address:PropertyAddress!, $lypsIntegration: Boolean) {
    fetchSubmarketId(address: $address, lypsIntegration: $lypsIntegration)
}`;
export {
    CREATE_JOIN_MUTATION,
    FETCH_SUBMARKET_ID
};
